const welcomeMessages = [
    "Good day, {{name}}! Welcome to our AI Waiter. What brings you here today?",
    "Hi {{name}}! Welcome to our AI Waiter. Ready to explore new ideas? How can I assist you?",
    "Greetings, {{name}}! Welcome to our AI Waiter. What's on your mind today that I can help with?",
    "Hello, {{name}}! Welcome back to our AI Waiter. How may I assist you further today?",
    "Hey {{name}}! Welcome to our AI Waiter. What's the plan for today? How can I be of service?",
    "Welcome back, {{name}}! Welcome to our AI Waiter. Let’s dive into your questions. What’s the first one?",
    "Hi there, {{name}}! Welcome to our AI Waiter. How can we make today a great day for you?",
    "Hello, {{name}}! Welcome to our AI Waiter. Looking forward to helping you. What do you need assistance with today?",
    "Hi {{name}}! Welcome to our AI Waiter. Glad you're here! What challenge can I help you tackle today?",
    "Welcome, {{name}}! Welcome to our AI Waiter. Tell me, what can I do for you today?",
];

export const getRandomWelcomeMessage = (name: string) => {
    const randomIndex = Math.floor(Math.random() * welcomeMessages.length);
    const randomMessage = welcomeMessages[randomIndex];

    return randomMessage.replace('{{name}}', name);
}